import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { authGuard } from '../../shared/auth/auth.guard';

export const admin: Routes = [
  {
    path: "bollette/estrazione-dati",
    loadComponent: () =>
      import("./bollette.component").then((m) => m.BolletteComponent),
    canActivate: [authGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(admin)],
  exports: [RouterModule],
})
export class bolletteRoutingModule {
  static routes = admin;
}
